export const warningMessages = {
    expiredSession:
        'Parece que tu sesión ha expirado. Por favor, vuelve a iniciar sesión para continuar disfrutando de nuestros servicios.',
    unauthorized:
        'Las credenciales que ingresaste son incorrectas. Por favor, vuelve a intentarlo.',
};
